export default __webpack_public_path__ + "static/media/mail.9049673b.svg";